module.exports = __webpack_public_path__ + "img/analytics-blue 2.685fc2b8.svg";